<template>
  <section id="wrapper">
    <div class="login-register">
      <div class="login-box card">
        <div class="card-body">
          <slot />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "AuthTheme",
  computed: {
    title() {
      return this.$store.state.route.meta.title;
    },
    loginPage() {
      return this.$store.state.route.meta.login === true;
    }
  }
};
</script>

<style>
@import "../assets/css/pages/login-register-lock.css";
</style>
